export const getDaysUntilEligible = (lastTakenDate, cooldownDays = 180) => {
    if (!lastTakenDate) return 0;

    const takenDate = new Date(Number(lastTakenDate));
    const now = new Date();
  
    takenDate.setHours(0, 0, 0, 0);
    now.setHours(0, 0, 0, 0);

    const nextEligibleDate = new Date(takenDate.getTime());
    nextEligibleDate.setDate(nextEligibleDate.getDate() + cooldownDays);

    const msDiff = nextEligibleDate - now;
    const daysRemaining = Math.ceil(msDiff / (1000 * 60 * 60 * 24));

    return daysRemaining > 0 ? daysRemaining : 0;
  };
  
  export const isEligibleForRetake = (lastTakenDate, cooldownDays = 180) => {
    const days = getDaysUntilEligible(lastTakenDate, cooldownDays);
    return days < 0;
  };